import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { 
    Card, 
    CardContent, 
    Grid, 
    Icon, 
    IconButton, 
    List, 
    ListItem, 
    ListItemIcon, 
    ListItemText, 
    Tooltip, 
    Typography,
    AppBar,
    Toolbar,
    Button,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const styles = theme => ({
    lessonCard: {
        height: '400px',
        overflow: 'auto',
        padding: '0px',
    },
    eventCard: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        paddingLeft: '8px',
        paddingRight: '8px',
    }
});

class SelfPacedCourseWeeklyView extends Component {

    state = {
        listIndexStart: 0,
        activeListItem: 0
    }

    handleArrowClick = (dir) => {
        const curIndex = this.state.listIndexStart
        if (dir === 'down') {
            return this.setState({ listIndexStart: curIndex - 3 })
        }
        return this.setState({ listIndexStart: curIndex + 3 })
    }

    handleListItemHover = (event) => {
        if (this.props.unavailableToClick.includes(event.company_calendar_event_id)) {
            return true
        }
        this.setState({ activeListItem: event.company_calendar_event_id })
        return true
    }

    handleListItemClick = (event) => {
        return this.props.history.push(`/${event.EventType.toLowerCase()}/student/` + event.company_calendar_event_id)
    }

    getEventStatusIcon = (event_info) => {
        if (event_info.IsRestricted) {
            return (
                <Tooltip title={"Prerequisites not met"}>
                    <Icon color={"disabled"}>assignment_returned</Icon>
                </Tooltip>
            )
        }
        
        switch (event_info.EventStatus)
        {
            case("Not Started"):
            {
                return (
                    <Tooltip title={event_info.EventStatus}>
                        <Icon>assignment</Icon>
                    </Tooltip>
                );
            }
            case("Retake Event"):
            case("Past Due"):
            {
                return (
                    <Tooltip title={event_info.EventStatus}>
                        <Icon style={{color: "red"}}>assignment_late</Icon>
                    </Tooltip>
                );
            }
            case("Waiting for Grade"):
            {
                return (
                    <Tooltip title={event_info.EventStatus}>
                        <Icon style={{ color: "orange" }}>assignment_turned_in</Icon>
                    </Tooltip>
                );
            }
            case("Is Graded"):
            case("Is Completed"):
            {
                return (
                    <Tooltip title={event_info.EventStatus}>
                        <Icon style={{color: "green"}}>assignment_turned_in</Icon>
                    </Tooltip>
                );
            }
            case("Failing Grade"):
            {
                return (
                    <Tooltip title={event_info.EventStatus}>
                        <Icon style={{ color: "red" }}>assignment_late</Icon>
                    </Tooltip>
                )
            }
        }
    }

    getEventTooltip = (event_info) => {
        let prereq_list = <Grid item xs={12}><Typography color="inherit" style={{ textDecoration: "underline" }}>No Prerequisites</Typography></Grid>;

        if (event_info.event_relation.length > 0) {
            prereq_list = (
            <React.Fragment>
                <Grid item xs={12}>
                    <Typography color="inherit" style={{ textDecoration: "underline" }}>Prerequisite List:</Typography>
                </Grid>
                {event_info.event_relation.map((event_rel_info, index) => {
                    return (
                        <React.Fragment key={event_rel_info.ChildEventID}>
                            <Grid item xs={8}>
                                <Typography color="inherit">- {event_rel_info.ChildEventName}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography color="inherit">({event_rel_info.ChildEventInfo.EventStatus})</Typography>
                            </Grid>
                        </React.Fragment>
                    )
                })}
            </React.Fragment>
            )
        }
        // console.log('event_info', event_info);
        
        return (
            <Grid container spacing={8}>
                <Grid item xs={6}>
                    <Typography color="inherit" style={{ textDecoration: "underline" }}>Event Type:</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography color="inherit">{(event_info.EventIsGradable ? '' : 'Ungraded ') + event_info.EventType}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography color="inherit" style={{ textDecoration: "underline" }}>Event Status:</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography color="inherit">{event_info.EventStatus}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography color="inherit" style={{ textDecoration: "underline" }}>Course Requirement:</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography color="inherit">{event_info.EventIsRequired ? 'Required to Pass Course' : 'Not Required'}</Typography>
                </Grid>
                {event_info.EventIsGradable && event_info.EventIsGraded ?
                    <React.Fragment>
                        <Grid item xs={6}>
                            <Typography color="inherit" style={{ textDecoration: "underline" }}>Event Grade:</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography color="inherit">{Number(event_info.EventScore).toFixed(1) + " / " + Number(event_info.EventTotalScore).toFixed(1)}</Typography>
                        </Grid>
                    </React.Fragment>
                : null}
                {prereq_list}
            </Grid>
        )
    }
    
    getCardStyle = (color) => {
        return {
            borderRadius: 4,
            borderWidth: 2,
            borderColor: color,
            width: '100%',
        }
    }

    getLessonCard = (lesson_info, i) => {
        const { classes, unavailableToClick } = this.props;
        const { listIndexStart } = this.state;

        const HtmlTooltip = withStyles((theme) => ({
            tooltip: {
                maxWidth: 600,
                fontSize: theme.typography.pxToRem(12),
                border: '1px solid #dadde9',
            },
        }))(Tooltip);
        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography color={"inherit"}>Lesson {listIndexStart + 1 + i}: {lesson_info.LessonName}</Typography>
                    </Toolbar>
                </AppBar>
                <Card>
                    <CardContent className={classes.lessonCard}>
                        <List
                            disablePadding={true}
                        >
                            {lesson_info.EventList.map((event_info, event_index) => {
                                return (
                                    <ListItem key={event_index}>
                                        <Card
                                            style={this.getCardStyle(event_info.EventColor)}
                                        >
                                            <CardContent className={classes.eventCard}>
                                                {this.getEventStatusIcon(event_info)}
                                                <Button 
                                                    onClick={() => this.handleListItemClick(event_info)}
                                                    style={{ textTransform: "none" }}
                                                    disabled={event_info.IsRestricted}
                                                >
                                                    {event_info.EventName}
                                                </Button>
                                                <HtmlTooltip 
                                                    title={this.getEventTooltip(event_info)}
                                                >
                                                    <Icon>info</Icon>
                                                </HtmlTooltip>
                                            </CardContent>
                                        </Card>
                                    </ListItem>
                                )
                            })}
                        </List>
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

    render() {
        const { events, unavailableToClick } = this.props
        const { listIndexStart } = this.state;
        return (
            <Grid container spacing={8}>
                <Grid item xs={1}>
                    <IconButton
                        onClick={() => this.handleArrowClick('down')}
                        disabled={listIndexStart === 0}
                    >
                        <Icon style={{ fontSize: '50px' }}>arrow_back</Icon>
                    </IconButton>
                </Grid>
                <Grid item xs={10}>
                    <Grid container spacing={8}>
                        {events.slice(listIndexStart, listIndexStart + 3).map((lesson_info, i) => {
                            return (
                                <Grid item xs={4} key={lesson_info.company_calendar_day_id}>
                                    {this.getLessonCard(lesson_info, i)}
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        onClick={() => this.handleArrowClick('up')}
                        disabled={listIndexStart + 4 > events.length}
                    >
                        <Icon style={{ fontSize: '50px' }}>arrow_forward</Icon>
                    </IconButton>
                </Grid>
            </Grid>

        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, null)(SelfPacedCourseWeeklyView)));


// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/SelfPacedCourseWeeklyView.js